'use strict';

var camelToDash = require('../../render/dom/utils/camel-to-dash.cjs');

const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + camelToDash.camelToDash(optimizedAppearDataId);

exports.optimizedAppearDataAttribute = optimizedAppearDataAttribute;
exports.optimizedAppearDataId = optimizedAppearDataId;
//# sourceMappingURL=data-id.cjs.map
